<template>
  <el-dialog title="图形验证码" :visible.sync="dialogVisible" width="30%" :before-close="cancel">
    <el-form ref="codeForm" :model="codeForm" :rules="codeRules" auto-complete="on" label-position="left" v-loading="codeLoading">
      <el-form-item prop="code" class="code">
        <div class="label">验证码</div>
        <el-input v-model="codeForm.code" placeholder="验证码" name="code" type="text" />
        <div class="img">
          <img class="code-area" v-if="codeImg" :src="codeImg" alt @click="getCodeImg" />
          <div class="code-area" v-else />
        </div>
      </el-form-item>
      <el-form-item class="codeBtn">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { getCaptcha } from "@/api/login";

export default {
  name: "codeImg",
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    value: {
      default() {
        return {};
      },
      type: Object,
    },
    // 刷新图片
    fresh: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      codeLoading: false,
      codeImg: '',
      codeForm: {
        code: "",
        sess: "",
      },
      codeRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      dialogVisible: false,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getCodeImg();
      }
    },
    codeForm: {
      handler(val) {
        this.$emit('update:value', val);
      },
      deep: true,
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    },
  },
  methods: {
    getCodeImg() {
      this.codeForm.code = "";
      this.codeLoading = true;
      getCaptcha().then((res) => {
        if (res.data.code === 0) {
          this.codeImg = res.data.captcha_url;
          this.codeForm.sess = res.data.captcha_key.replace('SIMP:', '');
        }
        this.codeLoading = false;
      }).catch(() => {
        this.codeLoading = false;
      });
    },
    submit() {
      this.dialogVisible = false;
      this.$emit('submit', true);
    },
    cancel() {
      this.$refs.codeForm.resetFields();
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.code /deep/.el-form-item__content {
  display: flex;
  align-items: center;

  .label {
    flex-shrink: 0;
    margin-right: 10px;
  }

  .img {
    display: flex;
    align-items: center;
  }

  .code-area {
    width: 140px;
    height: 48px;
    margin-left: 10px;
    cursor: pointer;
    border-radius: 8px;
  }
}
</style>
